import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

import { BrandingHeaderType } from 'rev-portal/branding/BrandingHeaderType';
import { CALENDAR_STATE_NAME } from 'rev-portal/scheduledEvents/webcast/Constants';
import { HeaderSettings, ThemeSettings } from 'rev-portal/branding/BrandingSettings.Contract';
import { MediaMenuService } from 'rev-portal/navigation/mediaMenu/MediaMenu.Service';

import { LoginRedirectService } from 'rev-shared/security/LoginRedirect.Service';
import { MediaFeaturesService } from 'rev-shared/media/MediaFeatures.Service';
import { PORTAL_TEAM_STATE, PORTAL_MEDIA_STATE, PORTAL_MEDIA_ALL_STATE, PORTAL_MEDIA_BROWSE_STATE } from 'rev-shared/bootstrap/AppStateNames';
import { SecurityContextService } from 'rev-shared/security/SecurityContext.Service';
import { UserContextService, IUserContextAccount } from 'rev-shared/security/UserContext.Service';

import { MobileSubMenu } from './MobileSubMenu.Constant';

import './mobile-menu.less';

@Component({
	selector: 'mobile-menu',
	templateUrl: './MobileMenu.Component.html',
	standalone: false
})

export class MobileMenuComponent implements OnInit {
	@Input() private readonly theme: BrandingHeaderType;
	@Input() private readonly headerSettings: HeaderSettings;
	@Input() private readonly themeSettings: ThemeSettings;
	@Input() public isAnalystAdmin: boolean;
	@Input() public showManageSubscriptions: boolean;
	@Input() public landingState: { state: string, params: any };
	@Input() public isGuestMode: boolean;

	public readonly PORTAL_TEAM_STATE = PORTAL_TEAM_STATE;
	public readonly PORTAL_MEDIA_STATE = PORTAL_MEDIA_STATE;
	public readonly PORTAL_MEDIA_ALL_STATE = PORTAL_MEDIA_ALL_STATE;
	public readonly PORTAL_MEDIA_BROWSE_STATE = PORTAL_MEDIA_BROWSE_STATE;
	public readonly CALENDAR_STATE_NAME = CALENDAR_STATE_NAME;

	private accountId: string;
	private subMenu: string;
	private ignoreDataFetch: boolean;
	public showHelpMenu: boolean;
	public enableCategories: boolean;
	public enablePublicWebcastAccess: boolean;

	constructor(
		public readonly $state: StateService,
		private readonly LoginRedirectService: LoginRedirectService,
		private readonly MediaMenuService: MediaMenuService,
		private readonly SecurityContext: SecurityContextService,
		private readonly UserContext: UserContextService,
		private readonly MediaFeaturesService: MediaFeaturesService
	) { }

	public ngOnInit(): void {
		this.MediaFeaturesService.getFeatures().then(features => {
			this.enableCategories = features.enableCategories;
			this.enablePublicWebcastAccess = features.enablePublicWebcastAccess;
		});
		this.accountId = this.UserContext.getAccount().id;
		this.ignoreDataFetch = this.SecurityContext.checkAuthorization('distribution.authenticated') || this.isGuestMode;
	}

	public get isNettrixTheme(): boolean {
		return this.theme === BrandingHeaderType.Nettrix;
	}

	public get showVideoMenu(): boolean {
		return this.subMenu === MobileSubMenu.Video;
	}

	public loginRedirect(): void {
		this.LoginRedirectService.redirectToLogin();
	}

	public onVideoMenuClick(): void {
		this.subMenu = this.subMenu === MobileSubMenu.Video ? undefined : MobileSubMenu.Video;
	}

	public onToggleClick(): void {
		if (this.ignoreDataFetch) {
			return;
		}
		this.MediaMenuService.fetchAllData();
	}

	public get account(): IUserContextAccount {
		return this.UserContext.getAccount();
	}
}
